import { render, staticRenderFns } from "./SignatureRejected.vue?vue&type=template&id=6e4c613e&scoped=true"
import script from "./SignatureRejected.vue?vue&type=script&lang=js"
export * from "./SignatureRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c613e",
  null
  
)

export default component.exports